import React from 'react';
import { DefaultQuestion, DefaultQuestionProps } from '../default/default';

interface ChoiceQuestionProps extends DefaultQuestionProps {}

export const ChoiceQuestion = ({
	question,
	answer,
	answerQuestion,
}: ChoiceQuestionProps) => {
	return (
		<>
			<DefaultQuestion
				question={question}
				answer={answer}
				answerQuestion={answerQuestion}
			/>
		</>
	);
};
